'use client';

import type { CellContext } from '@tanstack/react-table';
import { InterfaceChainUtils } from '@morpho-org/dapp-core';
import { MarketCell } from '@morpho-org/ui-v6/client';
import { InternalLink } from '@/components/common/InternalLink';
import { getMarketUrl } from '@/helpers/routing';
import { useViewedAccountAddress } from '@/hooks/useViewedAccountAddress';
import type { DashboardActivityTableFeatures } from '../config/DashboardActivity.config';
import type { LiquidationActivityTableRow } from '../config/DashboardActivity.types';
interface MarketCellWithLinkProps {
  row: CellContext<DashboardActivityTableFeatures, LiquidationActivityTableRow, unknown>['row'];
}
function MarketCellWithLink({
  row
}: MarketCellWithLinkProps) {
  // 'use no memo': TanStack keeps this object's reference while table state (sorting, rows) changes.
  'use no memo';

  const {
    isSelf
  } = useViewedAccountAddress();
  const identifier = InterfaceChainUtils.getIdentifierById(row.original.chainId);
  const collateralSymbol = row.original.collateralAsset?.symbol;
  const loanSymbol = row.original.loanAsset?.symbol;
  const marketUrl = row.original.marketId && collateralSymbol && loanSymbol ? getMarketUrl({
    identifier,
    marketId: row.original.marketId,
    collateralSymbol,
    loanSymbol,
    hash: isSelf ? 'yourPosition' : undefined
  }) : undefined;
  if (!marketUrl) {
    return <MarketCell collateralAsset={row.original.collateralAsset} loanAsset={row.original.loanAsset} chainId={row.original.chainId} lltv={row.original.lltv} />;
  }
  return <InternalLink href={marketUrl} withHoverEffect>
      <MarketCell collateralAsset={row.original.collateralAsset} loanAsset={row.original.loanAsset} chainId={row.original.chainId} lltv={row.original.lltv} className="gap-2xs" />
    </InternalLink>;
}
export default MarketCellWithLink;